import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatUrl } from '@ifeng-fe/three_terminal/es/base/publicMethod';
import styles from './index.css';
import Chip from 'Chip';

import Ad from '@ifeng-fe/ui_pc_ad';
// import { } from '@ifeng-fe/three_terminal/es/mobile/index';
import NewsStream from './newsStream';

class Content extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        columnId: PropTypes.string,
        ad: PropTypes.object,
    };

    render() {
        const { content, columnId, ad } = this.props;
        const { videoStream } = content;

        return (
            <Fragment>
                <div className={styles.content}>
                    <NewsStream content={videoStream} ad={ad} columnId={columnId} />
                </div>
            </Fragment>
        );
    }
}

export { Content };
export default Content;
